import { withStyles } from '@mui/styles';
import { TableSortLabel } from '@mui/material';

export const AntTableSortLabel = withStyles({
    icon: {
        opacity: 1,
    },
})(TableSortLabel);
